
import { defineComponent } from 'vue'
import { useFeatureAccess } from '@/composables/useFeatureAccess'

export default defineComponent({
  props: {
    slug: { type: String, required: true },
    kind: { type: String, required: true },
    externalIndex: { type: Number, default: undefined }
  },
  emits: ['export', 'copy', 'delete'],
  setup(props) {
    const { canWrite, canManage } = useFeatureAccess(() => props.kind)

    return {
      canEdit: canWrite,
      canExport: canWrite,
      canCopy: canWrite,
      canDelete: canManage
    }
  }
})
